<template>
  <div class="map-container" ref="mapContainer">
    <GmapMap
      :center="location"
      :zoom="17"
      map-type-id="terrain"
      :style="size">

      <GmapMarker
        :position="location"
        :clickable="true"
        :draggable="true"
        @click="setLocation"
        />

      <GmapCircle
        :center="location"
        :radius="radius" />
    </GmapMap>

  </div>
</template>

<script>
export default {
  props: {
    location: {
      type: Object
    },

		radius: {
			type: Number,
			defautl: 0
		}
  },

  data () {
    return {
      size: {}
    }
  },

  mounted: function () {
    this.size = this.styleMapSize
  },

  computed: {
    styleMapSize: function () {
      const container = this.$refs.mapContainer
      return {
        width: container.offsetWidth + 'px',
        height: container.offsetHeight + 'px'
      }
    }
  },

  methods: {
    setLocation: function () {
      if (window.confirm('このマーカーをクイズポイントに設定しますか？')) {
        this.$emit('setGeo', this.location)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: 100%;
}
</style>
